import _taggedTemplateLiteral from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _templateObject;
var _excluded = ["color", "gap", "thickness", "size", "speed"];
import React from "react";
import styled from "styled-components";
import { colors } from "../shared/styles";
function speedSwitch(speed) {
  if (speed === "fast") return 600;
  if (speed === "slow") return 900;
  return speed;
}
export var Loader = function Loader(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "rgba(0,0,0,0.4)" : _ref$color,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 4 : _ref$gap,
    _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? 4 : _ref$thickness,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 14 : _ref$size,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? "slow" : _ref$speed,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledSpinner, Object.assign({
    size: size,
    speed: speed,
    color: color
  }, props, {
    role: "img",
    "aria-labelledby": "title",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("title", {
    id: "title"
  }, "Circle loading spinner"), /*#__PURE__*/React.createElement("circle", {
    className: "path",
    role: "presentation",
    cx: 16,
    cy: 16,
    r: 14 - thickness / 2,
    fill: "none",
    strokeWidth: thickness,
    strokeDasharray: Math.PI * 2 * (11 - gap),
    strokeLinecap: "round"
  }));
};
export var StyledSpinner = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttransition-property: transform;\n\tanimation-name: rotate;\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: linear;\n\tanimation-duration: ", "ms;\n\twidth: ", "px;\n\theight: ", "px;\n\n\t& .path {\n\t\tstroke: ", ";\n\t\tstroke-linecap: round;\n\t\tanimation: dash 1.5s ease-in-out infinite;\n\t}\n\n\t@keyframes rotate {\n\t\tfrom {\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\tto {\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n"])), function (props) {
  return speedSwitch(props.speed);
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  var _colors$props$color;
  return (_colors$props$color = colors[props.color]) !== null && _colors$props$color !== void 0 ? _colors$props$color : props.color;
});